export default __webpack_public_path__ + "static/media/element_4.486eeac1.avif";